import axios from 'axios';

import { frontConfig } from '../config';
import { handleError } from './common-utils';
import { IS_DEV } from './optimization';
import { truncate } from './string';
import { buildYakliTargetUrl } from './yakliUrl';

// remove all html, keep only text
function strip(html: string) {
  const str = html.replace(/<br( \/)?>/gim, '\n');
  return str.replace(/<\/?[^>]+(>|$)/g, '');
}

export async function shortenUrl(
  {
    pageId,
    commentId,
    slug,
  }:
    | { pageId: string; commentId?: string; slug?: string }
    | { pageId?: string; commentId: string; slug?: string },
  fullBasepathUrl = '',
) {
  // @TODO test on internet explorer
  const baseHref = window.location.href.replace(window.location.search, '').split('/d/')[0];
  const url = buildYakliTargetUrl({ slug, commentId, pageId, fullBasepathUrl, baseHref });

  if (!frontConfig.yakliUrl) {
    const err = new Error(
      'No yakliUrl available in the front configuration, although it seems required in the code. To investigate. (AOL addition)',
    );
    if (IS_DEV) {
      throw err;
    } else {
      handleError(err);
    }
  }
  const { data } = await axios.post<{ short_url: string }>(frontConfig.yakliUrl as string, { url });

  return data;
}

function getTwitterMsg(content: string, byAuthor: string, shortUrl: string) {
  return [content, byAuthor, shortUrl, '@graphcomment'].filter(m => m).join(' ');
}

type ShareUrlPayload = {
  network: string;
  subject?: string;
  content: string;
  twitterUsername?: string | null;
  shortUrl: string;
};
function computeShareUrl({
  network,
  subject,
  content,
  twitterUsername,
  shortUrl,
}: ShareUrlPayload) {
  switch (network) {
    case 'facebook':
      return `http://www.facebook.com/sharer/sharer.php?u=${shortUrl}`;
    case 'linkedin':
      return `https://www.linkedin.com/shareArticle?mini=true&url=${shortUrl}&source=LinkedIn`;
    case 'twitter': {
      // @TODO use intl trad
      const byAuthor = twitterUsername ? `par ${twitterUsername}` : '';
      content = subject ? `${subject} - ${content}` : `Discussion à lire sur ${content}`;
      const baseLength = getTwitterMsg('', byAuthor, shortUrl).length;
      const twitterMaxLength = 280;
      const remainingChar = twitterMaxLength - baseLength;

      const commentContent = strip(content);

      const contentTruncated = truncate(commentContent, remainingChar, true);
      const trans = getTwitterMsg(contentTruncated, byAuthor, shortUrl);
      return `http://twitter.com/intent/tweet?text=${encodeURIComponent(trans)}`;
    }
    default:
      throw new Error(`Unknown network ${network}`);
  }
}

export async function openShareWindow({
  network,
  subject,
  content,
  twitterUsername,
  shortUrl,
}: ShareUrlPayload) {
  window.open(
    computeShareUrl({ network, subject, content, twitterUsername, shortUrl }),
    'Share',
    'width=700,height=700',
  );
}
